import { gql } from '@apollo/client';

const INIT_SHOPPING_BASKET_FILE_UPLOAD = gql`
  mutation InitShoppingBasketFileUpload($orderGroupId: Int!) {
    initShoppingBasketFileUpload(orderGroupId: $orderGroupId)
  }
`;

export default INIT_SHOPPING_BASKET_FILE_UPLOAD;
